import { IkioskManager, IKioskModel } from "models/kioskModel";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import { redirectPageAction } from "store/actions";
import "../../Kiosk.css";

const PatientJouneyExplore: React.FC = () => {
  const { t } = useTranslation("translations");
  const dispatch = useDispatch();
  const language = useSelector((state: any) => {
    if (state?.kioskReducer?.language)
      return (state.kioskReducer as IKioskModel).language;
    else return "";
  });

  return (
    <>
      <div className="kiosk-content bgImage">
        <div className="content-sec">
          <div className="welcometext">
            <div className="test">
              <h6>{t("Kiosk.welcome" + language)}</h6>
              <h2>{t("Kiosk.welcomeFp" + language)}</h2>
            </div>
            <div className="lg_cards">
              <button
                className="languagebtn"
                onClick={() =>
                  dispatch(
                    redirectPageAction(IkioskManager.EMIRADESVERIFICATION)
                  )
                }
              >
                {t("Kiosk.yes" + language)}
              </button>
              <button
                className="languagebtn"
                onClick={() =>
                  dispatch(
                    redirectPageAction(IkioskManager.EXISTPATIENTJOUNEYPAGE)
                  )
                }
              >
                {t("Kiosk.no" + language)}
              </button>
              {/* <p style={{ color: "white" }}>{t("Kiosk.ready" + language)}</p> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default React.memo(PatientJouneyExplore);
